import type { ReactNode } from 'react';
import { DetailsStep } from '@/modules/agreements/platform/pages/document-create-page/parts/details-step';
import { ContentStep } from '@/modules/agreements/platform/pages/document-create-page/parts/content-step';
import { RequirementStep } from '@/modules/agreements/platform/pages/document-create-page/parts/requirement-step';
import { ReviewStep } from '@/modules/agreements/platform/pages/document-create-page/parts/review-step';
import type { DocumentDraft } from '@/modules/agreements/platform/pages/document-create-page/types';

/** The four step ids, in order. */
export type AuthoringStepId = 'details' | 'content' | 'requirement' | 'review';

/**
 * Renders the body of one authoring step.
 *
 * A single switch rather than four separate step definitions, because the step
 * DEFINITIONS (labels, descriptions, validation) belong to the page that owns
 * the journey, while the step BODIES belong to `parts/`. Splitting them this way
 * keeps every `parts/` import inside the page folder, which is what the
 * component-boundary rule requires, and keeps the page's step list readable as
 * data.
 */
export function StepBody(props: {
  step: AuthoringStepId;
  draft: DocumentDraft;
  onChange: (patch: Partial<DocumentDraft>) => void;
}): ReactNode {
  const { step, draft, onChange } = props;
  switch (step) {
    case 'details':
      return <DetailsStep draft={draft} onChange={onChange} />;
    case 'content':
      return <ContentStep draft={draft} onChange={onChange} />;
    case 'requirement':
      return <RequirementStep draft={draft} onChange={onChange} />;
    case 'review':
      return <ReviewStep draft={draft} />;
  }
}
